import { Title, Flex, Button } from '@mantine/core';
import { modals } from '@mantine/modals';

import {
  CreateWhitelistForm,
  WhitelistTable,
  useCreateWhitelist,
  useGetWhitelist,
} from '@/modules/whitelist';

export const Whitelist = () => {
  const {
    data,
    isLoading,
  } = useGetWhitelist();

  const { handleCreateWhitelist } = useCreateWhitelist();

  const openCreateModal = () => modals.open({
    title: 'Добавление в белый список',
    centered: true,
    children: (
      <CreateWhitelistForm
        onSubmit={handleCreateWhitelist}
        onClose={modals.closeAll}
      />
    ),
  });

  return (
    <>
      <Flex justify="space-between" align="center" w="100%" mb={10}>
        <Title order={4}>Белый список</Title>

        <Button
          variant="filled"
          onClick={openCreateModal}
        >
          Создать
        </Button>
      </Flex>

      <WhitelistTable
        items={data ?? []}
        isLoading={isLoading}
      />
    </>
  );
};
